import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { history as historyPropTypes } from 'history-prop-types';
import PropTypes from 'prop-types';
import React from 'react';

import { absolute } from '../../components/AnimatedRoutes';
import { getDataRequest, verifyDataRequest } from '../../../../ducks/user/mydata';
import { navigate } from '../../../../helpers';
import Button from '../../components/Button';
import Content from '../../components/Content';
import Empty from '../../components/Empty';
import Header from '../../components/Header';
import Loader from '../../components/Loader';
import Subheader from '../../components/Subheader';
import styles from './DataCard/data-card.scss';

const propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    state: PropTypes.string,
    type: PropTypes.string,
    created_at: PropTypes.string,
  })),
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.shape(historyPropTypes),
  loading: PropTypes.bool,
  saving: PropTypes.bool,
  /* location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }), */
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      requestId: PropTypes.string,
    }),
  }),
};

Loader.propTypes = {
  loading: PropTypes.bool,
  screen: PropTypes.element,
};

class VerifyDataRequest extends React.Component {
  componentDidMount() {
    const { dispatch, match } = this.props;
    const { requestId } = match && match.params;
    dispatch(getDataRequest(requestId));
  }

  btnVerify = (id) => () => {
    const { dispatch, history } = this.props;
    dispatch(verifyDataRequest(id))
      .then(() => navigate(history, '/app/me/data'));
  }

  render() {
    const {
      loading,
      saving,
      data,
      match,
      history,
    } = this.props;
    const { requestId: id } = match.params;
    const request = data && data.filter((req) => req && req.id === id);
    /* eslint-disable no-mixed-operators */
    const { state, type } = request && request[0] || {};
    /* eslint-enable no-mixed-operators */

    const matrix = {
      export: {
        short: <FormattedMessage
          id="dataverify.matrix.export.short"
          defaultMessage="Export your personal data"
        />,
        description: <FormattedMessage
          id="dataverify.matrix.export.description"
          defaultMessage="This action will trigger an export of all personal data DreamHack stores related to you. You will receive an email with a link to download the personal data as soon as the export is complete."
        />,
        btnConfirm: {
          text: <FormattedMessage
            id="dataverify.matrix.export.btnText"
            defaultMessage="Start export"
          />,
          onClick: this.btnVerify,
        },
      },
      delete: {
        short: <FormattedMessage
          id="dataverify.matrix.delete.short"
          defaultMessage="Delete your personal data"
        />,
        description: <FormattedMessage
          id="dataverify.matrix.delete.description"
          defaultMessage="This action is non-reversible and will delete all personal data DreamHack stores related to you. After the data has been deleted you will no longer be able to log in to your account nor request access to it."
        />,
        btnConfirm: {
          text: <FormattedMessage
            id="dataverify.matrix.delete.btnText"
            defaultMessage="Delete my personal data"
          />,
          onClick: this.btnVerify,
        },
      },
    };

    return (
      <>
        <Header onBack={() => navigate(history, '/app/me/data')}>
          <FormattedMessage
            id="dataverify.header"
            defaultMessage="Verify data request"
          />
        </Header>
        <Content>
          <Loader loading={loading} />
          { !loading && type && state && state === 'new'
            && (
              <>
                <Subheader>
                  {matrix[type].short}
                </Subheader>
                <div className={styles.dataCard}>
                  <p>{matrix[type].description}</p>
                  <Button
                    onClick={matrix[type].btnConfirm.onClick(id)}
                    disabled={saving}
                  >
                    {matrix[type].btnConfirm.text}
                  </Button>
                </div>
              </>
            )}
          <Empty
            empty={!loading && (!state || !type || (state && state !== 'new'))}
            title={(
              <FormattedMessage
                id="dataverify.empty.title"
                defaultMessage="This request is invalid"
              />
)}
            message={(
              <FormattedMessage
                id="dataverify.empty.message"
                defaultMessage="This request is no longer valid. Please check your request status."
              />
)}
            button={{
              text: <FormattedMessage
                id="dataverify.empty.btnText"
                defaultMessage="Check request status"
              />,
              onClick: () => navigate(history, '/app/me/data'),
            }}
          />
        </Content>
      </>
    );
  }
}

VerifyDataRequest.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    data: state.getIn(['mydata', 'data']),
    loading: state.getIn(['mydata', 'loading']),
    saving: state.getIn(['mydata', 'saving']),
    error: state.getIn(['mydata', 'error']),
  };
}

export default injectIntl(connect(mapStateToProps)(absolute(VerifyDataRequest)));
